(ns rothko.theme.sandi.panel
  (:refer-clojure :exclude [rem])
  (:require [garden.units :as units :refer [rem percent]]
            [rothko.styles.vars.basic :as basic]))

(def main
  {:primary
   {:background-color (:white basic/colours)
    :border-top [[(rem 0.3) :solid (:black basic/colours)]]
    :box-shadow (:deep-shadow basic/shadows)
    :flex-shrink 0
    :padding (rem 1)
    :overflow :auto}

   :auto-margin
   {:margin :auto}

   :no-border
   {:border-top :none}

   :no-padding
   {:padding 0}

   :selectable
   {:cursor :pointer
    :background-color--hover (basic/colours :grey-bg-gradient-light)}

   :text-align-centre
   {:text-align :center}})
